import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';  
import VerticalNavbar from './components/Navbar'; 
import Body from './components/Body';         
import Login from './components/Login';
import Register from './components/Register';
import EmailVerify from './components/EmailVerify.js';
import ChangePassword from './components/ChangePassword.js';
import Lead from './components/Lead';         
import Leadlist from './components/Lead/leadlist.js';
import LeadEdit from './components/Lead/LeadEdit.js';  
import Communication from './components/Lead/Communication.js'; 
import Leadby from './components/Lead/Leadby.js';  
import DeleteLeads from './components/Lead/DeleteLeads.js';  
import Assignedtasks from './components/admin/Assignedtasks.js'; 
import AllReports from './components/admin/AllReports.js';
import AllTickets from './components/admin/AllTickets.js'; 
import PlanDetails from './components/admin/PlanDetails.js';
import AllWorkDoc from './components/admin/AllWorkDoc.js';
import AllReqDoc from './components/admin/AllReqDoc.js';
import EmpInfo from './components/admin/EmpInfo.js';
import UserAddServices from './components/admin/UserAddServices.js';
import AddManager from './components/manager'; 
import ManagerList from './components/manager/mlist.js'; 
import EditManager from './components/manager/EditManager';
import Emplist from './components/manager/emplist.js';
import AssignedEmp from './components/manager/AssignedEmp.js';
import ManageTickets from './components/manager/ManageTickets.js';
import MyTask from './components/manager/MyTask.js';
import Users from './components/manager/Users.js';
import LeadUsers from './components/manager/LeadUsers.js';
import AddEmployee from './components/Employee';
import Employeelist from './components/Employee/Employeelist';
import EditEmployee from './components/Employee/EditEmployee';
import AssigningTickets from './components/Employee/AssigningTickets.js';
import TransferTicket from './components/Employee/TransferTicket.js';
import WorkedDocs from './components/Employee/WorkedDocs.js';
import DocRequest from './components/Employee/DocRequest.js';
import ReplyDoc from './components/Employee/ReplyDoc.js';
import AssignedTask from './components/Employee/AssignedTask.js';
import Quries from './components/Employee/Quries.js';
import EmpRaiseTicket from './components/Employee/EmpRaiseTicket.js';
import DisWorkedDoc from './components/Employee/DisWorkedDoc.js';
import Tqueries from './components/Employee/Tqueries.js';
import TicketQueries from './components/User/TicketQueries.js';
import AddUser from './components/User';
import UserList from './components/User/Userlist.js';
import DisplayWorkedDoc from './components/User/DisplayWorkedDoc.js';
import DisplayDocRequest from './components/User/DisplayDocRequest.js';
import UserQueries from './components/User/UserQueries.js';
import UserInfo from './components/User/UserInfo.js';
import UserPayment from './components/User/UserPayment.js';
import RaiseTicket from './components/Ticket/RaiseTicket.js';
import UserTicket from './components/Ticket/UserTicket.js';
import GreetingSms from './components/Messages/GreetingSms.js';
import WatiGreetings from './components/Messages/WatiGreetings.js';
import GST from './components/Messages/GST.js';
import WatiGST from './components/Messages/WatiGST.js';
import Leadwait from './components/Messages/Leadwait.js';
import LeadSms from './components/Messages/LeadSms.js';
import Payment from './components/payment';
import PreformaInvoice from './components/payment/PreformaInvoice.js';
import AddPayment from './components/payment/AddPayment.js';
import WebTranscation from './components/payment/WebTranscation.js';
import ProformaList from './components/payment/ProformaList.js';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router basename="/">
      {/* ProtectedRoute wrapping the entire layout with the VerticalNavbar */}
      <Routes>
        {/* Login route */}
        
        <Route path="/login" element={<Login />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/EmailVerify" element={<EmailVerify />} />
        <Route path="/ChangePassword/:token" element={<ChangePassword />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Body />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/DeleteLeads"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <DeleteLeads />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/AllWorkDoc"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AllWorkDoc />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ProformaList"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <ProformaList />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/EmpInfo/:id"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <EmpInfo />
                </div>
              </div>
            </ProtectedRoute>
          }
        />
      
        <Route
          path="/AllReports"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AllReports />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/UserAddServices/:uid"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <UserAddServices />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/AllReqDoc"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AllReqDoc />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

      
        <Route
          path="/WebTranscation"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <WebTranscation />
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/AddPayment"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AddPayment />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

         <Route
          path="/PreformaInvoice"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <PreformaInvoice />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/MyTask"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <MyTask />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Leadlist"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Leadlist />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Lead"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Lead />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/AssigningTickets"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AssigningTickets />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/communication/:id"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Communication/>
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        {/* Add the route for LeadEdit with dynamic ID */}
        <Route
          path="/edit-lead/:id"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <LeadEdit />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Leadby"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Leadby />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Assignedtasks"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Assignedtasks />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/AllTickets"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AllTickets />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/PlanDetails"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <PlanDetails />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/manager"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AddManager />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/mlist"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <ManagerList />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        {/* Update the route to include the :id parameter for editing manager */}
        <Route
          path="/Manager/edit/:id"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <EditManager />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

      <Route
          path="/AssignedEmp"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AssignedEmp />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/DisplayWorkedDoc"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <DisplayWorkedDoc />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/DocRequest"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <DocRequest />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ReplyDoc"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <ReplyDoc />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ManageTickets"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <ManageTickets />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Users"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Users />
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/DisplayDocRequest"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <DisplayDocRequest />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/RaiseTicket"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <RaiseTicket />
                </div>
              </div>
            </ProtectedRoute>
          }
        />


        <Route
          path="/LeadUsers"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <LeadUsers />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Emplist"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Emplist />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Employee"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AddEmployee />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Employeelist"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Employeelist />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Employee/edit/:id"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <EditEmployee />
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/AssignedTask"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AssignedTask />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/DisWorkedDoc"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <DisWorkedDoc />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/EmpRaiseTicket"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <EmpRaiseTicket />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Quries/:task_uniqueid"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Quries />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Tqueries/:ticket_id"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Tqueries />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/TicketQueries/:ticket_id"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <TicketQueries />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/WorkedDocs"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <WorkedDocs />
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/UserQueries"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <UserQueries />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/TransferTicket"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <TransferTicket />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/User"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <AddUser />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/UserPayment"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <UserPayment />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Userlist"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <UserList />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/UserTicket"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <UserTicket />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/UserInfo/:id"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <UserInfo />
                </div>
              </div>
            </ProtectedRoute>
          }
        />


        <Route
          path="/GreetingSms"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <GreetingSms />
                </div>
              </div>
            </ProtectedRoute>
          }
        />


        <Route
          path="/GST"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <GST />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/WatiGST"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <WatiGST />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Leadwait"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Leadwait />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/LeadSms"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <LeadSms />
                </div>
              </div>
            </ProtectedRoute>
          }
        />


        <Route
          path="/WatiGreetings"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <WatiGreetings />
                </div>
              </div>
            </ProtectedRoute>
          }
        />


        <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <div className='d-flex'>
                <VerticalNavbar /> {/* Protected Navbar */}
                <div className="w-100 ">
                  <Payment />
                </div>
              </div>
            </ProtectedRoute>
          }
        />




      </Routes>
    </Router>
  );
}

export default App;
